import "@/assets/styles/layouts/Text.css";

import { accountFormat } from "@/Common/helpers/number";
import { Button, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import { isEmpty } from "lodash";
import { ChangeEvent, FocusEvent, useState } from "react";

interface MoneyInputProps {
	label?: string;
	value: number | null;
	onChange: (value: number | null) => void;
	min?: number;
	max?: number;
	placeholder?: string;
	nullable?: boolean;
	sx?: object;
	labelClassName?: string;
	fontSize?: string;
}

const MoneyInput = ({
	label,
	value,
	onChange,
	min,
	max,
	placeholder = "0.00",
	nullable = true,
	sx = {},
	labelClassName = "",
	fontSize = "16px",
}: MoneyInputProps) => {
	const [displayValue, setDisplayValue] = useState<string>(value !== null ? value.toFixed(2) : "");

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const inputValue = e.target.value;
		if (isEmpty(inputValue) && nullable) {
			setDisplayValue("");
			onChange(null);
			return;
		}

		const regex = /^-?\d*\.?\d{0,2}$/;
		if (regex.test(inputValue)) {
			setDisplayValue(inputValue);
		}
	};

	const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
		const inputValue = e.target.value;

		if (isEmpty(inputValue) && nullable) {
			setDisplayValue("");
			onChange(null);
			return;
		}

		let numValue = parseFloat(inputValue) || 0;

		if (min !== undefined && numValue < min) {
			numValue = min;
		}
		if (max !== undefined && numValue > max) {
			numValue = max;
		}

		setDisplayValue(accountFormat(numValue));
		onChange(numValue);
	};

	const handleFocus = () => {
		if (displayValue) {
			setDisplayValue(parseFloat(displayValue).toString());
		}
	};

	return (
		<Stack direction="row" position="relative" alignContent="center" alignItems="center">
			{label && (
				<Typography className={labelClassName || "regular-montserrat-label"} sx={{ fontSize }}>
					{label}
				</Typography>
			)}
			<TextField
				autoComplete="off"
				type="text"
				value={displayValue}
				onChange={handleChange}
				onBlur={handleBlur}
				onFocus={handleFocus}
				placeholder={placeholder}
				className="regular-text-input"
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<Button className="start-button disabled-button" disabled disableRipple>
								$
							</Button>
						</InputAdornment>
					),
				}}
				sx={{ width: "95px", marginLeft: 1, ...sx }}
				size="small"
			/>
		</Stack>
	);
};

export default MoneyInput;
